import React, { useState, useEffect } from 'react';
import ParticipantSelector from './components/ParticipantSelector';
import LocationSelector from './components/LocationSelector';
import RotationList from './components/RotationList';
import TaskHistoryModal from './components/TaskHistoryModal';
import Navbar from './components/Navbar';
import { getTextColorForBackground } from './utils/colorUtils';

function App() {
  const [step, setStep] = useState(1);
  const [participants, setParticipants] = useState([]);
  const [locations, setLocations] = useState([]);
  const [theme, setTheme] = useState('light'); 
  const [isModalOpen, setIsModalOpen] = useState(false); 
  const [tasks, setTasks] = useState([]); 

  const handleParticipantsChange = (newParticipants) => {
    setParticipants(newParticipants);
  };

  const handleLocationsChange = (newLocations) => {
    setLocations(newLocations);
  };

  const handleNextStep = () => {
    if (step === 1) {
      setStep(2);
    } else if (step === 2 && locations.length > 0) {
      setStep(3);
    }
    window.scrollTo(0, 0); // Desplazar al inicio de la página
  };

  const handleReset = () => {
    setStep(1);
    setParticipants([]);
    setLocations([]);
    setTasks([]);
    localStorage.removeItem('step'); // Eliminar step de localStorage
    localStorage.removeItem('tasks'); // Eliminar tareas de localStorage
    window.scrollTo(0, 0); // Desplazar al inicio de la página

  };

  const toggleTheme = () => {
    setTheme(prevTheme => prevTheme === 'light' ? 'dark' : 'light');
  };

  const toggleModal = () => {
    setIsModalOpen(prev => !prev);
  };

  useEffect(() => {
    const root = document.documentElement;

    if (theme === 'dark') {
      root.style.setProperty('--primary-color', '#1a1a1a');
      root.style.setProperty('--secondary-color', '#2d2d2d');
      root.style.setProperty('--accent-color', '#4a4a4a');
      root.style.setProperty('--background-color', '#121212');
      root.style.setProperty('--text-color', getTextColorForBackground('#121212'));
    } else {
      root.style.setProperty('--primary-color', '#ff9aa2');
      root.style.setProperty('--secondary-color', '#ffb7b2');
      root.style.setProperty('--accent-color', '#b5ead7');
      root.style.setProperty('--background-color', '#fff1e6');
      root.style.setProperty('--text-color', getTextColorForBackground('#fff1e6'));
    }
  }, [theme]);

  // Cargar tareas desde localStorage
  useEffect(() => {
    const savedStep = localStorage.getItem('step');
    const savedTasks = localStorage.getItem('tasks');

    if(savedStep){
      try{
        setStep(JSON.parse(savedStep));
      }catch (error){
        console.error('Error parsing step from localStorage', error);
      }
    }

    if(savedTasks){
      try{
        setTasks(JSON.parse(savedTasks));
      } catch (error){
        console.error('Error parsing tasks from localStorage', error);
      }
    }
    //if(savedStep) setStep(JSON.parse(savedStep));
    //if (savedTasks) setTasks(JSON.parse(savedTasks));
  }, []);

  // Guardar tareas en localStorage cada vez que cambian
  useEffect(() => {
    if(step !== 1)  localStorage.setItem('step', JSON.stringify(step));
    if(tasks.length > 0) localStorage.setItem('tasks', JSON.stringify(tasks));
  }, [step, tasks]);

  //console.log(participants);
  //console.log(locations);
  console.log(tasks);

  return (
    <div className={`App ${theme === 'dark' ? 'dark-theme' : ''}`}>
      {step === 1 && (
        <ParticipantSelector
          onParticipantsChange={handleParticipantsChange}
          participants={participants}
        />
      )}
      {step === 2 && (
        <LocationSelector
          onLocationsChange={handleLocationsChange}
          locations={locations}
        />
      )}
      {step === 3 && (
        <RotationList
          participants={participants}
          locations={locations}
          //onReset={handleReset}
          setTasks={setTasks}
          tasks={tasks}
        />
      )}

      {/* Barra de navegación */}
      <Navbar
        step={step}
        toggleModal={toggleModal}
        toggleTheme={toggleTheme}
        onReset={handleReset}
        onContinue={handleNextStep}
        isContinueEnabled={step !== 2 || locations.length > 0} // Solo valida las ubicaciones en el paso 2
      />

      {/* Modal de Historial de Tareas */}
      <TaskHistoryModal isOpen={isModalOpen} toggleModal={toggleModal} tasks={tasks} />
    </div>
  );
}

export default App;
